import BaseAPI from '@/apis/base/baseApi';

class DVCIntergrationAPI extends BaseAPI {
  apiName = 'Integration';
  controllerName = 'DVC';

  /**
   * Kích hoạt sự kiện: Lấy dữ liệu từ DVC cập nhật cột trạng thái tại danh sách hồ sơ
   * @param {String} payload
   * @returns
   * @author nvthinh 15.11.2023
   */
  triggerEvent(payload) {
    const request = {
      url: this.getAPIUrl() + '/trigger-event',
      data: payload,
    };
    return this.postAsync(request);
  }
}

export default new DVCIntergrationAPI();
